import { render, staticRenderFns } from "./UserSettingsDropdown.vue?vue&type=template&id=e9309f0e&"
import script from "./UserSettingsDropdown.vue?vue&type=script&lang=js&"
export * from "./UserSettingsDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports